import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getHighlight } from "../Service/Api";

const Highlights = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getHighlight();

        const filteredData = response.filter(
          (item) => item.school === "Senior" || item.school === "Both"
        );

        setData(filteredData);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const emptyData = [
    { id: 1, title: "Stay Tuned For More Updates" },
    { id: 2, title: "Stay Tuned For More Updates" },
    { id: 3, title: "Stay Tuned For More Updates" },
  ];

  const marqueeData = data.length > 0 ? data : emptyData;

  return (
    <div className="mun-highlight-marquee">
      <marquee behavior="scroll" direction="left" scrollAmount="6">
        {marqueeData.map((item, index) => (
          <span key={index} style={{ marginRight: "40px" }}>
            {item.url ? (
              <Link
                to={item.url}
                target="_blank"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                {item.title}
              </Link>
            ) : (
              item.title
            )}

            {item.attachments?.length > 0 && (
              <>
                {" "}
                <Link
                  to={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`}
                  target="_blank"
                  title="Attachment"
                >
                  <i className="bi bi-paperclip"></i>
                </Link>
              </>
            )}

            {"  •  "}
          </span>
        ))}
      </marquee>
    </div>
  );
};

export default Highlights;